import React from "react";
import Navbar from "../components/navbar/Navbar";
import Simplechart from "../components/tradingview/Simplechart";
import Tickertape from "../components/tradingview/Tickertape";
import Marketdata from "../components/tradingview/Marketdata";
import Cryptomarket from "../components/tradingview/Cryptomarket";
import "./mercadostyle.css";
export default function MercadoInternacional() {
  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <Tickertape />
        </div>
      </div>

      <div className="row" style={{ marginTop: "10px" }}>
        <div className="col-md-6">
          <h3>Gráfico em Tempo Real</h3>
          <div>
            <Simplechart />
          </div>
        </div>

        <div className="col-md-6">
          <h3>Dados de Mercado</h3>
          <div>
            <Marketdata />
          </div>
        </div>
      </div>
    </>
  );
}
